/**
 * Views that can be turned on or off via the top bar menus.
 * These view on / off states are persisted to device settings.
 */
export enum ViewType {
  SIDEBAR = "SIDEBAR",
  // This is the data overview pane (input / output files, etc).
  DATA_PANE = "DATA_PANE",
  MODELS_PANE = "MODELS_PANE",
  // This is the detailed "Add data" pane, i.e. KM DataSourceSelector.
  ADD_DATA_PANE = "ADD_DATA_PANE",
  ADD_MODELS_PANE = "ADD_MODELS_PANE",
  SELECT_MODEL_INSTANCE_PANE = "SELECT_MODEL_INSTANCE_PANE",
  // This is the detailed "Add data" pane, initialized with utility script
  // filters. i.e. KM DataSourceSelector w/utilityScriptMode set to 'true'.
  ADD_DATA_PANE_FOR_UTILITY_SCRIPTS = "ADD_DATA_PANE_FOR_UTILITY_SCRIPTS",
  COMPETITIONS_PANE = "COMPETITIONS_PANE",
  SETTINGS_PANE = "SETTINGS_PANE",
  ADD_ONS_PANE = "ADD_ONS_PANE",
  DEBUG_PANE = "DEBUG_PANE",
  SNIPPETS_PANE = "SNIPPETS_PANE",
  SCHEDULE_PANE = "SCHEDULE_PANE",
  JUPYTER_DEV_TOOLS = "JUPYTER_DEV_TOOLS",
  // TODO(cochamberlain): Add tracking of expansion to Redux state.
  JUPYTER_DEV_TOOLS_EVENTS_PANE = "JUPYTER_DEV_TOOLS_EVENTS_PANE",
  JUPYTER_DEV_TOOLS_REDUX_PANE = "JUPYTER_DEV_TOOLS_REDUX_PANE",
  INTERACTIVE_SESSIONS = "INTERACTIVE_SESSIONS",
  COMMIT_SESSIONS = "COMMIT_SESSIONS",
  METRIC_PANE = "METRIC_PANE",
}
